<template>
  <div class="platform-pie">
    <ChartBox :option="option" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import ChartBox from "@/components/xiaofeiTradeData/ChartBox.vue";
import { formatPrice, platformAverage } from "./priceData";

const platformData = [
  { name: "抖音电商", key: "douyin", value: 28.9 },
  { name: "拼多多", key: "pdd", value: 17.6 },
  { name: "京东", key: "jd", value: 25.9 },
  { name: "淘宝", key: "taobao", value: 22 },
  { name: "本地商城", key: "local", value: 5.6 },
].map((item) => ({
  ...item,
  price: `${formatPrice(platformAverage(item.key))}元`,
}));

const countyAverage = formatPrice(
  platformData.reduce((sum, item) => sum + platformAverage(item.key) * item.value, 0) / 100
);

const option = computed(() => ({
  color: ["#05a8ff", "#725cf6", "#13c4ff", "#1d72ff", "#15d4c3"],
  tooltip: {
    trigger: "item",
    textStyle: { fontSize: 30 },
    formatter: ({ name, value, data }) => `${name}<br/>占比：${value}%<br/>均价：${data.price}`,
  },
  legend: {
    show: true,
    type: "plain",
    orient: "horizontal",
    right: "23%",
    bottom: 0,
    icon: "roundRect",
    itemWidth: 26,
    itemHeight: 10,
    itemGap: 30,
    // backgroundColor: "rgba(13, 88, 170, 0.72)",
    // borderColor: "rgba(58, 207, 255, 0.9)",
    // borderWidth: 2,
    // borderRadius: 2,
    padding: [10, 16],
    textStyle: {
      color: "#d9f4ff",
      fontSize: 18,
      fontWeight: "bold",
    },
    data: platformData.map((item) => item.name),
  },
  series: [
    {
      type: "pie",
      silent: true,
      radius: ["80%", "81%"],
      center: ["50%", "48%"],
      label: { show: false },
      data: [{ value: 1 }],
      itemStyle: {
        color: "transparent",
        borderColor: "rgba(42, 160, 255, 0.48)",
        borderWidth: 2,
        borderType: "dashed",
      },
      z: 0,
    },
    {
      type: "pie",
      radius: ["45%", "69%"],
      center: ["50%", "48%"],
      minAngle: 8,
      avoidLabelOverlap: true,
      label: {
        show: true,
        color: "#bdefff",
        fontWeight: "bold",
        lineHeight: 36,
        formatter: ({ name, value, data }) =>
          `{name|${name}}  {percent|${value.toFixed(1)}%}\n {price|${data.price}}`,
        rich: {
          name: { color: "#d8f7ff", fontSize: 22, fontWeight: "bold" },
          percent: { color: "#8ee6ff", fontSize: 22, fontWeight: "bold" },
          price: { color: "#bff0ff", fontSize: 24, fontWeight: "bold" },
        },
      },
      labelLine: {
        show: true,
        length: 26,
        length2: 58,
        lineStyle: { width: 2 },
      },
      itemStyle: {
        borderWidth: 8,
        borderColor: "#071e43",
        borderRadius: 14,
      },
      emphasis: {
        scale: true,
        scaleSize: 6,
        itemStyle: {
          shadowBlur: 18,
          shadowColor: "rgba(34, 207, 255, 0.45)",
        },
      },
      data: platformData,
      z: 2,
    },
    {
      type: "pie",
      silent: true,
      radius: ["35%", "37%"],
      center: ["50%", "48%"],
      label: { show: false },
      data: [{ value: 1 }],
      itemStyle: {
        color: "rgba(8, 31, 80, 0.35)",
        borderColor: "rgba(34, 204, 255, 0.75)",
        borderWidth: 2,
      },
      z: 1,
    },
  ],
  graphic: [
    {
      type: "circle",
      left: "center",
      top: "36%",
      shape: { r: 88 },
      style: {
        fill: "rgba(10, 41, 91, 0.72)",
        stroke: "rgba(65, 214, 255, 0.75)",
        lineWidth: 3,
        shadowBlur: 18,
        shadowColor: "rgba(33, 210, 255, 0.35)",
      },
      z: 0,
    },
    {
      type: "text",
      left: "center",
      top: "44%",
      style: {
        text: "全县综合均价",
        fill: "#dff7ff",
        fontSize: 22,
        fontWeight: "bold",
        align: "center",
      },
    },
    {
      type: "text",
      left: "center",
      top: "49%",
      style: {
        text: `${countyAverage}元`,
        fill: "#f2fbff",
        fontSize: 34,
        fontWeight: "bold",
        align: "center",
      },
    },
  ],
}));
</script>

<style lang="less" scoped>
.platform-pie {
  height: 100%;
  position: relative;
}
</style>
